import {
  apiFetchClient,
  KittlHeaderNames,
  type APIFetchMiddleware,
} from '@repo/api-client';

import { useWorkspaceStore } from 'stores/workspaceStore';

export enum Header {
  AUTHORIZATION = 'Authorization',
}

export const initApiFetchClient = (): void => {
  /**
   * This middleware will also be used internally by the api-client
   * It is used to:
   * - Add headers to the request
   * - Add specific handling for errors
   */
  const apiFetchMiddleware: APIFetchMiddleware = {
    // auth token is added for us automatically by the api-client middleware
    onRequest({ request }) {
      const workspaceId = useWorkspaceStore.getState().activeWorkspaceId;

      if (workspaceId && !request.headers.has(KittlHeaderNames.WORKSPACE_ID)) {
        request.headers.set(KittlHeaderNames.WORKSPACE_ID, workspaceId);
      }
      return request;
    },
    onError({ error }) {
      return new Error(
        error instanceof Error ? error.message : 'Unknown error'
      );
    },
  };

  // Apply the middleware to the apiFetchClient
  apiFetchClient.use(apiFetchMiddleware);
};
